import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { getUser } from "../api/auth.api.js";

export function PrivateRoute() {
  const user = getUser();
  return user ? <Outlet /> : <Navigate to="/login" />;
}
